import addresses from '../constants/contract'

export const getAddress = (chainId: number, of: 'factory' | 'info' | 'staking' | 'usdt') => {
  let address: any =  addresses[of]
  return address[chainId]
}